const DEFAULT_FES_ADDRESS = '36 Avenue Ibn Khatib, Fès';
const DEFAULT_PHONE = '06 61 70 00 52';

/**
 * Branch contact details for in-store-only product modal (region-aware).
 */
export function getInStoreBranchInfo(settings, isCasaRegion) {
  if (isCasaRegion) {
    const address = settings?.branch_casa_address || '';
    const phone =
      settings?.branch_casa_phone ||
      settings?.footer_phone_casa ||
      settings?.footer_phone1 ||
      DEFAULT_PHONE;

    return {
      regionLabel: settings?.branch_casa_name || 'Casablanca',
      addresses: address ? [address] : [],
      phones: [phone].filter(Boolean),
    };
  }

  const addresses = [
    settings?.branch_fes1_address || DEFAULT_FES_ADDRESS,
    settings?.branch_fes2_address,
  ].filter(Boolean);

  const phones = [
    settings?.branch_fes1_phone,
    settings?.branch_fes2_phone,
    settings?.footer_phone_fes,
    settings?.footer_phone1,
    DEFAULT_PHONE,
  ].filter((phone, index, arr) => phone && arr.indexOf(phone) === index);

  return {
    regionLabel: 'Fès',
    addresses,
    phones: phones.length ? phones : [DEFAULT_PHONE],
  };
}
